import React, { Component } from 'react'
import { AppBar, Button, Dialog, DialogActions, DialogContent, Toolbar, Typography, } from '@material-ui/core'
import { withStyles } from '@material-ui/core/styles/index'
import { bindActionCreators } from 'redux'
import { UecareAvatar, UecareDropdown, UecareInput } from '../../../../components'
import ReduxGlobal from '../../../../store/actionreducers/globalView'
import ReduxVip from '../../../../store/actionreducers/vip'
import { connect } from 'react-redux'
import moment from 'moment'
import _ from 'lodash'
import { constDataDialogs } from '../../../../constants'

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    addressButton: {
        margin: theme.spacing.unit * 1 / 2,
    },
    formControl: {
        marginBottom: 24
    },
})

const initNewVipState = {
    group: {
        type: {
            name: ''
        }
    },
    user: {
        family_name: '',
        given_name: '',
        nickname: '',
        cell_phone_no: '',
        backup_phone: '',
        id_no: '',
        email: '',
        password: '',
        sex: '',
        birthday: moment().format('YYYY-MM-DD'),
        avatar: { url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png' },
    },
    visit_address: {
        city: { id: 1, name: '台北市' },
        address: '',
        status: { id: 24, label: 'applying' }
    },
    habit: '',
    ill_history: '',
}

const initControlState = {
    occId: '',
    areaCode: '',
    setOccVerified: '',
    occVerifiedAt: null,
    continentId: 0,
    livingAreaId: 0,
}

class OccDialog extends Component {

    constructor(props) {
        super(props)

        this.state = {
            vip: initNewVipState,
            ...initControlState,
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.props.occDialog) return // skip if no occDialog

        const prevOpen = prevProps.occDialog && prevProps.occDialog.props.open
        if (prevOpen && !this.props.occDialog.props.open) return

        const { vip, vip: { user }, livingArea } = this.props
        if (_.isEqual(vip, prevState.vip)) return

        const areaCodeLivingArea = livingArea.find(la => la.ocac_code === user.occ_area_code)

        this.setState({
            vip,
            occId: user.occ_number,
            areaCode: user.occ_area_code,
            setOccVerified: '',
            occVerifiedAt: user.occ_verified_at,
            continentId: areaCodeLivingArea ? areaCodeLivingArea.fk_continent_id : 0,
            livingAreaId: areaCodeLivingArea ? areaCodeLivingArea.id : 0,
        })
    }

    closeDataDialog = () => {
        this.props.closeDataDialog({ name: constDataDialogs.name.occDialog })
    }

    _updateVip = async action => {
        try {
            const {
                autoVerifyOcc,
                closeLoadingMask,
                getVip,
                refreshVips,
                openLoadingMask,
                updateOccVerifyStatus,
                livingArea,
            } = this.props

            const {
                vip: { id: vipId },
                occId,
                areaCode: prevAreaCode,
                livingAreaId,
                setOccVerified,
                occVerifiedAt,
            } = this.state

            const la = livingArea.find(la => la.id === livingAreaId)
            const areaCode = la ? la.ocac_code : prevAreaCode
            const isVerified = setOccVerified ? !!occVerifiedAt : setOccVerified === 'setVerified'

            openLoadingMask()
            if (action === 'verify') await autoVerifyOcc({ vipId, occId, areaCode })
            if (action === 'save') await updateOccVerifyStatus({ vipId, occId, areaCode, isVerified })
            await refreshVips()
            if (action === 'verify') await getVip(vipId)
            closeLoadingMask()
            if (action === 'save') this.closeDataDialog()
        } catch (e) {
            console.warn('you got an error = ', e)
        }
    }

    render() {
        if (!this.props.occDialog || !this.props.occDialog.props.open) return <div/>

        const {
            classes,
            livingArea,
            continent,
            occDialog,
        } = this.props

        const {
            vip: { user },
            occId,
            setOccVerified,
            occVerifiedAt,
            continentId,
            livingAreaId,
        } = this.state

        return (
            <Dialog
                className={classes.root}
                {...occDialog.props}
                onClose={this.closeDataDialog}
                fullWidth
                maxWidth="xs"
            >
                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">僑胞卡卡號驗證</Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <UecareAvatar
                            className="w-96 h-96"
                            src={user.avatar ? user.avatar.url : 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'}
                        />
                        <Typography variant="title" color="inherit" className="pt-8">{user.name}</Typography>
                        <Typography variant="title" color="inherit" className="pt-8">{user.email}</Typography>
                        <Typography variant="title" color="inherit" className="pt-8">{`+${user.phone_country_code} ${user.phone_number}`}</Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{ root: 'p-24' }}>
                    <UecareInput
                        label="僑胞卡卡號"
                        icon="picture_in_picture"
                        name="id_no"
                        id="id_no"
                        className={classes.formControl}
                        value={occId || ''}
                        onChange={(event) => this.setState({ occId: event.target.value })}
                    />

                    <UecareDropdown
                        label="洲別"
                        icon="map"
                        name="continent"
                        id="continent"
                        className={classes.formControl}
                        value={continentId || 0}
                        options={continent}
                        onChange={(event, selectedOption) => this.setState({
                            continentId: selectedOption.id,
                            livingAreaId: 0,
                        })}
                    />

                    <UecareDropdown
                        label="居住地區"
                        icon="place"
                        name="living_area"
                        id="living_area"
                        className={classes.formControl}
                        value={livingAreaId || 0}
                        options={livingArea.filter(livingArea => continentId && livingArea.fk_continent_id === continentId)}
                        onChange={(event, selectedOption) => this.setState({ livingAreaId: selectedOption.id })}
                    />

                    <UecareInput
                        label="驗證狀態"
                        icon="verified_user"
                        name="updated_at"
                        id="updated_at"
                        className={classes.formControl}
                        value={(occVerifiedAt ? moment(occVerifiedAt).format('已於 YYYY-MM-DD HH:mm 驗證') : occId ? '驗證失敗' : '無')}
                        onChange={() => false}
                        disabled
                    />

                    <UecareDropdown
                        label="修改驗證狀態"
                        icon="verified"
                        name="status"
                        id="status"
                        className={classes.formControl}
                        value={setOccVerified}
                        options={[
                            { id: 'setVerified', name: '設為驗證成功' },
                            { id: 'setFailed', name: '設為驗證失敗' },
                        ]}
                        onChange={(event, selectedOption) => this.setState({ setOccVerified: selectedOption.id })}
                    />
                </DialogContent>

                <DialogActions>
                    <Button variant="raised" color="secondary" onClick={() => this._updateVip('verify')}>自動驗證</Button>
                    <Button variant="raised" color="primary" onClick={() => this._updateVip('save')}>儲存</Button>
                </DialogActions>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        refreshVips: ReduxVip.ActionCreator.refreshVips,
        getVip: ReduxVip.ActionCreator.getVip,
        autoVerifyOcc: ReduxVip.ActionCreator.autoVerifyOcc,
        updateOccVerifyStatus: ReduxVip.ActionCreator.updateOccVerifyStatus,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch)
}

function mapStateToProps({ global: { dataDialogs }, city: { livingArea, continent }, vip: { vip } }) {
    return {
        occDialog: dataDialogs[constDataDialogs.name.occDialog],
        vip,
        livingArea,
        continent,
    }
}

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps, mapDispatchToProps)(OccDialog))



// WEBPACK FOOTER //
// ./src/main/content/callHelper/vip/OccDialog.js